<template>
  <div class="pic-list">
    <ul>
      <li
        class="pic-item"
        v-for="(v, index) in list"
        :key="v.uploadUrl + index"
        @click="showBig(index)"
      >
        <div class="img-container">
          <img :src="v.imageHost + v.uploadUrl" :alt="v.label" />
        </div>
        <div class="label-container">{{ v.label }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
// 展示图片
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";
export default {
  name: "CardFieldPic",
  functional: true,
  data() {
    return {
      picUrl: "http://ddmc-test-1256883318.image.myqcloud.com"
    };
  },
  created() {
    this.list.forEach(item => {
      item.url = item.imageHost + item.uploadUrl;
      item.label = item.describe;
    });
  },
  props: {
    list: {
      // 图片列表 {url: '', label: ''}
      type: Array,
      default: () => {
        const obj = {
          url:
            "https://ddmc-ddfs-public-1256883318.cos.ap-shanghai.myqcloud.com/img/blind/product-management/202107/0ba38f50beaf4fc89fed356d2893957b.jpeg?width=800&height=800",
          label: "发霉"
        };
        const arr = [];
        for (let i = 0; i < 0; i++) {
          arr.push(obj);
        }
        return arr;
      }
    },
    fieldData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    showBig(index) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const $viewer = viewerApi({
        options: {
          toolbar: false,
          url: "url",
          initialViewIndex: index,
          title: function() {
            return that.list[index].label;
          },
          inline: true
        },
        images: this.list
      });
    }
  }
};
</script>
<style lang="less">
.pic-list {
  padding-top: 10px;
  overflow: hidden;
  ul,
  li {
    list-style: none;
  }
  .pic-item {
    width: 25%;
    height: 0;
    float: left;
    padding: 0 15px 30% 15px;
    box-sizing: border-box;
    .img-container {
      border: 1px dashed #6c6c6c;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .label-container {
      width: 100%;
      color: #33c658;
      font-size: 14px;
      line-height: 1.8;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
